import ComponentInitializer from '../libs/component-initializer.js';
import ComponentBase from './base/component-base.js';

class History extends ComponentBase {

  constructor(element: HTMLElement) {
    super(element);
    setTimeout(() => {
      this.start();
    }, 1);
  }

  private start(){
    this.element.classList.add('is-start');
  }

  
}

ComponentInitializer.initializeComponent('.js-history', History);